import React from "react";

import { Chip as DsmChip } from "@plum-xoxo/admin-dsm";

import styled from "styled-components";

const Chip = styled(DsmChip).attrs()`
  height: 24px;
  width: 100%;
  justify-content: center;

  border: 1px solid
    ${(props) =>
      props.theme.palette[props?.backgroundColor]
        ? props.backgroundColor
          ? props?.backgroundColor === "primary"
            ? props.theme.palette[props?.backgroundColor].c01
            : props?.backgroundColor === "light"
            ? props.theme.palette[props?.backgroundColor].c300
            : props.theme.palette[props?.backgroundColor].c100
          : ""
        : ""};
`;

const status = {
  1: "Approval Pending",
  2: "Scheduled",
  4: "Cancelled",
  0: "Cancelled",
};

const greenChipProps = {
  color: "custom",
  backgroundColor: "green",
  backgroundShade: "c000",
  textColor: "green",
  textShade: "c300",
};

const greyChipProps = {
  color: "custom",
  backgroundColor: "light",
  backgroundShade: "c200",
  textColor: "dark",
  textShade: "c200",
};

const redChipProps = {
  color: "custom",
  textColor: "red",
  textShade: "c200",
  backgroundColor: "red",
  backgroundShade: "c000",
};
const blueChipProps = {
  color: "custom",
  textColor: "primary",
  textShade: "c02",
  backgroundColor: "primary",
  backgroundShade: "c00",
};
const yellowChipProps = {
  color: "custom",
  textColor: "yellow",
  textShade: "c300",
  backgroundColor: "yellow",
  backgroundShade: "c000",
};

const chipProps = {
  success: greenChipProps,
  redeemed: greenChipProps,
  delivered: blueChipProps,
  complete: greenChipProps,
  active: greenChipProps,
  recommended: greenChipProps,
  inactive: redChipProps,
  "not delivered": greyChipProps,
  scheduled: greyChipProps,
  "finance pending": greyChipProps,
  "partially redeemed": yellowChipProps,
  "verification required": yellowChipProps,
  "approval pending": yellowChipProps,
  "coming soon": blueChipProps,
  pending: yellowChipProps,
  cancelled: redChipProps,
  canceled: redChipProps,
  cancel: redChipProps,
  "": {
    color: "primary",
  },
};

const StatusChip = (props) => {
  let { value = "" } = props;

  if (Number(value) || Number(value) === 0) {
    value = status[value];
  }

  const valueLowerCase = value?.toString()?.toLowerCase();

  return (
    <Chip
      label={value}
      radius={8}
      variant="fill"
      {...chipProps[valueLowerCase]}
      {...props}
    />
  );
};

export default StatusChip;
